import { TaskCenterTypes, TaskCenterTypesV2 } from '@frontend/api-task-center';

export const getUpdatedFilters = (
  taskFilters: Partial<TaskCenterTypes.Task>,
  locationId: string[]
): TaskCenterTypesV2.SchemaTypes.FiltersV2 => {
  const filters: TaskCenterTypesV2.SchemaTypes.FiltersV2 = { locationId };

  if (taskFilters.source) {
    filters['source'] = taskFilters.source;
  }
  if (taskFilters.sourceId) {
    filters['sourceId'] = [taskFilters.sourceId];
  }
  if (taskFilters.status) {
    filters['status'] = [taskFilters.status];
  }
  if (taskFilters.assignee) {
    filters['assignee'] = [taskFilters.assignee];
  }
  if (taskFilters.priority) {
    filters['priority'] = [taskFilters.priority];
  }
  return filters;
};
